import React from 'react'

import { localizer } from '../../Translator'

import { Container } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Backdrop, CircularProgress } from "@material-ui/core"
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'

import ScreenHeading from '../common/ScreenHeading';
import { TextFieldStyled } from '../common/InputStyled';
import { TableRowHeaderStyled, TableRowStyled, TableCellStyled} from '../common/TableStyled.js'
import { TableStyled } from '../common/TableStyled.js'
import { GridHeaderFilter } from '../common/HeaderComponentStyled.js';

import { SnackbarCustom } from "../Utilities/SnackbarCustom"
import CurrencyCustom from '../Utilities/CurrencyCustom.js';
import Roles from "../Utilities/Roles.js"

import ProductCli from '../../sdk/ProductCli.js';
import CycleCli from '../../sdk/CycleCli.js';
import OutboxCli from '../../sdk/OutboxCli.js';

import { BillingShipmentRow } from './sections/BillingShipmentRow';
import ReportCli from '../../sdk/ReportCli.js';
import AuthCli from "../../sdk/AuthCli.js";

const SHIPMENT_PAGE_SIZE = 50
const SHIPMENT_PAGE_SIZE_OPTIONS = [50, 100, 200]
const MAX_DATE_RANGE_MONTHS = 3
const EMPTY_TRACKINGS = []

let INITAL_FILTERS = {
  productCode: [],
  emittedSince: null,
  emittedUntil: null,
  shipmentCode: null,
  reference: null,
  postalCode: null,
  locality: null,
  who: null,
  streetName: null,
  //stateCode: [],
  stateCode: ["DEL","DLD", "DLO","DIE","EPD","EPR", "SNT","PRG","PRI","EXP","LST","NIF","NRC","OND","WAY","OTH","OUT", "PRE","RPO","RJT", "REJ","RET","SPR", "SH", "STL", "UNK", "UP","WAD"],
  userId: [],
  cancelRequested: false,
  canceled: false, //only canceltime=null
}

export class BillingLayout extends React.Component {
  // Initializes the billing list state, filters, and pagination settings.
  constructor(props) {
    super(props)
    this.state = {
      shipments: [],
      trackings: [],
      trackingsByShipment: {},
      pagesLoaded: 0,
      endOfShipments: false,
      pageSize: SHIPMENT_PAGE_SIZE,
      totalShipments: 0,
      maxKnownPage: 0,

      // Totals data from shipments
      totalPages: 0,
      totalCost: 0,

      // List of products to filter
      products: [],
      // Filter
      filters: INITAL_FILTERS,

      // Error message in case API call fail
      errormessage: null,
      infomessage: null,

      // Flag to display circular progress when an API call is executing
      isLoading: false,
    }
  }

  // Validates the current session and loads initial billing filter data for administrators.
  componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        if (session.role !== Roles.ROLE_ADMIN.Name) {
          window.location.href = "shipment"
        } else {
          this.getAllProducts()
          this.setDateFilter()
        }
      }
    })
  }

  // Sets the date filter to the complete previous calendar month.
  setDateFilter = () => {
    const now = new Date();
    // Previous month (January rolls back to December of the previous year).
    const prevMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
    const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
  
    // First day of the previous month.
    const emittedSince = `${year}-${String(prevMonth + 1).padStart(2, '0')}-01`;
  
    // Last day of the previous month.
    const lastDay = new Date(year, prevMonth + 1, 0).getDate();
    const emittedUntil = `${year}-${String(prevMonth + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
  
    let newFilters = { ...this.state.filters };
    newFilters.emittedSince = emittedSince;
    newFilters.emittedUntil = emittedUntil;
  
    this.setState({
      emittedSince,
      emittedUntil,
      filters: newFilters
    });
  }

  // Loads the current page of billable shipments and their tracking codes.
  getShipmentsOfBillable = async (filters, manageLoading = true) => {
    if (!this.state.isLoading) this.setState({ isLoading: true })
    await OutboxCli.GetShipmentsOfBillable(this.state.pageSize, this.state.pagesLoaded, true, true, false, filters).then(async data => {
      
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ errormessage: data.substring(data.indexOf(' ')) })
      } else {
        const shipments = Array.isArray(data) ? data : []

        if (shipments.length > 0) {
          let shipmentcodes = shipments.map(s => { return s.shipmentCode })

          /*trackings*/
          let trackings = await this.getAssignedCodes(shipmentcodes)
          const trackingsByShipment = trackings.reduce((groupedTrackings, tracking) => {
            if (!groupedTrackings[tracking.shipmentCode]) groupedTrackings[tracking.shipmentCode] = []
            groupedTrackings[tracking.shipmentCode].push(tracking)
            return groupedTrackings
          }, {})

          this.setState({
            shipments: shipments,
            trackings: trackings,
            trackingsByShipment: trackingsByShipment
          })
        } else {
          this.setState({ shipments: [], trackings: [], trackingsByShipment: {}, totalPages: 0, totalCost: 0 })
        }

        const maxKnownPage = this.getMaxPageFromCount()
        this.setState({
          endOfShipments: this.state.pagesLoaded >= maxKnownPage,
          maxKnownPage: maxKnownPage,
          errormessage: null
        })

        if (shipments.length === 0) {
          this.setState({ infomessage: localizer.NotFoundBillingData })
        } else {
          this.setState({ infomessage: null })
        }
      }
      if (manageLoading) this.setState({ isLoading: false })
    })
  }

  // Loads global shipment, page, and cost totals for the active filters.
  getShipmentsCount = async (filters) => {
    const response = await OutboxCli.GetShipmentBillingTotalsOfBillable(true, false, false, filters)

    if (response !== null && response !== undefined && response.toString().startsWith("[ERR")) {
      this.setState({ errormessage: response.substring(response.indexOf(' ')), totalShipments: 0, totalPages: 0, totalCost: 0 })
      return 0
    }

    const total = Number(response && response.totalShipments)
    const safeTotal = Number.isFinite(total) && total >= 0 ? total : 0
    const totalPages = Number(response && response.totalPages)
    const safeTotalPages = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
    const totalCost = Number(response && response.totalCost)
    const safeTotalCost = Number.isFinite(totalCost) && totalCost >= 0 ? totalCost : 0

    this.setState({ totalShipments: safeTotal, totalPages: safeTotalPages, totalCost: safeTotalCost }, () => {
      const maxKnownPage = this.getMaxPageFromCount()
      if (this.state.maxKnownPage !== maxKnownPage) {
        this.setState({ maxKnownPage: maxKnownPage })
      }
    })

    return safeTotal
  }

  // Loads global totals and the current shipment page in parallel while keeping the spinner visible.
  loadBillingData = async (filters) => {
    this.setState({ isLoading: true })
    await Promise.all([
      this.getShipmentsCount(filters),
      this.getShipmentsOfBillable(filters, false)
    ])
    this.setState({ isLoading: false })
  }

  // Retrieves tracking codes for the shipments displayed in the current page.
  getAssignedCodes = async (shipmentcodes) => {
    let trackings = []
    await CycleCli.GetAssignedCodes(shipmentcodes).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response })
      } else {
        let filtered = response.filter(d => d !== null && d.codeValue !== "" && d.codeType === "CODE_TRACKING")
        trackings = filtered
      }
    })
    return trackings
  }

  // Updates one filter value and clears results that no longer match the pending filter.
  onInputChange = (event) => {
    let filters = { ...this.state.filters };
    const { name, value, type } = event.target;
  
    if (type === "date") {
      filters[name] = value || '';
    } else {
      filters[name] = value;
    }
  
    // Reset the shipments list when the user change the filter. Otherwise data will do not correspond to the filter
    this.setState({ filters, shipments: [], trackings: [], trackingsByShipment: {}, pagesLoaded: 0, endOfShipments: false, totalShipments: 0, totalPages: 0, totalCost: 0 });
  }

  // Resets pagination and loads the first billing page for the selected filters.
  doViewBillingList = () => {
    if (this.isDateRangeExceedingMaxMonths()) return
    
    this.setState({ pagesLoaded: 0, endOfShipments: false, shipments: [], totalShipments: 0, totalPages: 0, totalCost: 0 }, () => {
      const filters = this.normalizeShipmentFilters(this.state.filters)
      this.loadBillingData(filters)
    })
  }

  // Converts UI date values into inclusive API filter values without mutating component state.
  normalizeShipmentFilters = (filtersInput) => {
    const filters = { ...filtersInput }

    // Include the whole selected end date in the API date range.
    if (filters.emittedUntil && /^\d{4}-\d{2}-\d{2}$/.test(filters.emittedUntil)) {
      let dateTime = new Date(filters.emittedUntil)
      dateTime.setDate(dateTime.getDate() + 1)
      dateTime.setMinutes(dateTime.getMinutes() - 1)
      filters.emittedUntil = dateTime
    } else {
      filters.emittedUntil = null
    }

    if (filters.emittedSince && !/^\d{4}-\d{2}-\d{2}$/.test(filters.emittedSince)) {
      filters.emittedSince = null
    }

    return filters
  }

  // Parses an HTML date input value (YYYY-MM-DD) into a local Date object.
  parseDateInput = (value) => {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null

    const date = new Date(value + "T00:00:00")
    return Number.isNaN(date.getTime()) ? null : date
  }

  // Validates that the selected date range does not exceed three months.
  isDateRangeExceedingMaxMonths = () => {
    const sinceDate = this.parseDateInput(this.state.filters.emittedSince)
    const untilDate = this.parseDateInput(this.state.filters.emittedUntil)
    if (!sinceDate || !untilDate) return false

    const maxAllowedUntilDate = new Date(sinceDate)
    maxAllowedUntilDate.setMonth(maxAllowedUntilDate.getMonth() + MAX_DATE_RANGE_MONTHS)
    return untilDate > maxAllowedUntilDate
  }

  // Computes the last available 0-based page index from global totals and the selected page size.
  getMaxPageFromCount = () => {
    const total = Number(this.state.totalShipments || 0)
    const pageSize = Number(this.state.pageSize || SHIPMENT_PAGE_SIZE)
    if (total <= 0 || pageSize <= 0) return 0

    return Math.max(Math.ceil(total / pageSize) - 1, 0)
  }

  // Loads a selected page while keeping the current filters and global totals.
  handleChangePage = (newPage) => {
    const maxPage = this.getMaxPageFromCount()
    if (newPage < 0 || newPage > maxPage) return

    const filters = this.normalizeShipmentFilters(this.state.filters)
    this.setState({
      pagesLoaded: newPage
    }, () => {
      this.getShipmentsOfBillable(filters)
    })
  }

  // Updates the page size, returns to the first page, and reloads only shipment rows.
  handleChangeRowsPerPage = (event) => {
    const newPageSize = parseInt(event.target.value, 10)
    const filters = this.normalizeShipmentFilters(this.state.filters)
    this.setState({
      pageSize: Number.isFinite(newPageSize) ? newPageSize : SHIPMENT_PAGE_SIZE,
      pagesLoaded: 0,
      maxKnownPage: 0
    }, () => {
      this.getShipmentsOfBillable(filters)
    })
  }

  // Restores the default previous-month date range.
  doCleanFilters = () => { this.setDateFilter() }
    
  // Loads products used to render shipment product descriptions.
  getAllProducts = () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  // Generates and downloads the billing Excel report for the active filters.
  doGenerateBillingReport = async () => {
    if (this.isDateRangeExceedingMaxMonths()) return

    this.setState({ isLoading: true })
    let filters = { ...this.state.filters }
        
    if (filters.emittedSince && filters.emittedUntil) {
      let dateTime = new Date(filters.emittedUntil)
      dateTime.setDate(dateTime.getDate() + 1)
      dateTime.setMinutes(dateTime.getMinutes() - 1)
      filters.emittedUntil = dateTime
    }
    
    await ReportCli.DownloadBillingReportOfBillableExcel(filters).then((error) => {
      if (error) this.setState({ errormessage: error.substring(error.indexOf(' ')) })
      else this.setState({ errormessage: null })
    })
    this.setState({ isLoading: false })
  }

  // Renders the billing filters, paged shipment table, global totals, and loading feedback.
  render() {
    const emittedSince = this.state.filters.emittedSince || '';
    const emittedUntil = this.state.filters.emittedUntil || '';
    const hasShipments = this.state.shipments && this.state.shipments.length > 0
    const isDateRangeBlocked = this.isDateRangeExceedingMaxMonths()
    // Material-UI pagination works with 1-based pages, while internal state uses 0-based index.
    const totalPages = Math.max(this.getMaxPageFromCount() + 1, 1)
    const currentPage = Math.min(this.state.pagesLoaded + 1, totalPages)
    return (
      <React.Fragment>

        <Container maxWidth="xl">
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-file-invoice-dollar icon-button-header mr-20 ml-20"></i>} title={localizer.ReportBilling} />
          
          <GridHeaderFilter container direction="row" justify="center" alignItems="center" style={{ borderRadius: "5px 5px 5px 5px" }} className="p-15">
            <Grid item container direction="row">
              <Grid item md={6} className="text-align-left">
                <Typography className="typography-generic bigweight text-align-left">{localizer.FindShipments}</Typography>
              </Grid>
              <Grid item md={6} className=" text-align-right">
                <Button className="button-generic filter" variant="outlined" onClick={this.doCleanFilters} startIcon={<i className="fa-solid fa-broom"></i>}>
                  {localizer.CleanFilter}
                </Button>
              </Grid>
            </Grid>
            
            <Grid container item md={12} spacing={2}>

              <Grid item md={2}>
                <TextFieldStyled className="bg-white" variant='standard' style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                  id="emittedSince" name="emittedSince" fullWidth
                  onChange={this.onInputChange} type="date"
                  value={emittedSince}
                  label={<Typography className="typography-generic mt-5neg">{localizer.Since}</Typography>}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                    },
                    inputProps: {
                      max: "9999-12-31"
                    } 
                  }}
                />
              </Grid>
              <Grid item md={2}>
                <TextFieldStyled className="bg-white" style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                  id="emittedUntil" name="emittedUntil" onChange={this.onInputChange} type="date"
                  value={emittedUntil} fullWidth
                  label={<Typography className="typography-generic mt-5neg">{localizer.Until}</Typography>}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                    },
                    inputProps: {
                      max: "9999-12-31"
                    } 
                  }}
                />
              </Grid>
            </Grid>
            {isDateRangeBlocked &&
              <Grid item md={12}>
                <Typography className="typography-generic" style={{ color: "red", marginTop: 6 }}>
                  {localizer.OutboxDateRangeMaxThreeMonths || "Lo sentimos no es posible realizar consultas de más de tres meses"}
                </Typography>
              </Grid>
            }
          </GridHeaderFilter>

          <Grid container direction="row" justify={hasShipments ? "space-between" : "flex-end"} alignItems="center">
            {hasShipments &&
              <Grid item>
                <Typography className="typography-generic">
                  {localizer.TotalShipments}: <b>{CurrencyCustom.numberFormatter(this.state.totalShipments)}</b> &nbsp;&nbsp;
                  {localizer.TotalDisplayed}: <b>{CurrencyCustom.numberFormatter(this.state.shipments.length)}</b>
                </Typography>
              </Grid>
            }
            <Grid item>
              <Button className="button-generic downloadTable" variant="outlined" onClick={this.doGenerateBillingReport} disabled={isDateRangeBlocked} startIcon={<i className="fa-solid fa-file-excel"></i>}>
                {localizer.ReportBillingGenerateXLS}
              </Button>
              <Button className="button-generic downloadTable" variant="outlined" onClick={this.doViewBillingList} disabled={isDateRangeBlocked} startIcon={<i className="fa-solid fa-table-list"></i>}>
                {localizer.ReportBillingViewList}
              </Button>
            </Grid>
          </Grid>

          {/* Main container of the screen's content. */}
          <Grid container direction="row">
            {/* Billing table data  */}
            {this.state.shipments && this.state.shipments.length > 0 &&
              <Grid container direction="row">

                <TableContainer component={Paper}>
                  <TableStyled aria-label="collapsible table">
                    <TableHead>
                      <TableRowHeaderStyled>
                        <TableCellStyled />
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Date}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Client}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.UserEmail}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.ShipmentCode}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Type}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.PrintType}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Pages}</Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Cost}</Typography></TableCellStyled>
                      </TableRowHeaderStyled>
                    </TableHead>
                    <TableBody>
                      {(this.state.shipments && this.state.shipments.length > 0) ?
                        this.state.shipments.map((shipment) => (
                          <BillingShipmentRow
                            key={shipment.shipmentCode}
                            shipment={shipment}
                            trackings={this.state.trackingsByShipment[shipment.shipmentCode] || EMPTY_TRACKINGS}
                            products={this.state.products}
                          />
                        ))
                        :
                        <TableRowStyled><TableCellStyled colSpan={8} className="typography-generic tablerow-content font-weight-bold" align="center">{this.state.isLoading ? localizer.WaitingData : localizer.NotFound}</TableCellStyled></TableRowStyled>
                      }
                      {(this.state.shipments && this.state.shipments.length > 0) &&
                        <TableRowStyled className="billing-total-row">
                          <TableCellStyled colSpan={2} className="typography-generic tablerow-content font-weight-bold" align="center">{localizer.TotalBillingShipments + " " + CurrencyCustom.numberFormatter(this.state.totalShipments || 0)}</TableCellStyled>
                          <TableCellStyled colSpan={5}></TableCellStyled>
                          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" align="center">{localizer.TotalPages + ": " + CurrencyCustom.numberFormatter(this.state.totalPages || 0)}</TableCellStyled>
                          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" align="center">{localizer.TotalCost + ": " + (this.state.totalCost ? CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, this.state.totalCost / 100) : 0)}</TableCellStyled>
                        </TableRowStyled>
                      }
                    </TableBody>
                  </TableStyled>
                </TableContainer>
                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ paddingTop: 25 }}>
                  <Grid item>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, flexWrap: 'nowrap' }}>
                      <span className="typography-generic">
                        {localizer.RowsPerPage || "Envíos por página"}:
                      </span>
                      <Select
                        value={this.state.pageSize}
                        onChange={this.handleChangeRowsPerPage}
                        variant="outlined"
                        className="typography-generic"
                        style={{ height: 35, backgroundColor: 'white', minWidth: 88 }}
                        renderValue={(selected) => <span className="typography-generic">{selected}</span>}
                      >
                        {SHIPMENT_PAGE_SIZE_OPTIONS.map((option) => (
                          <MenuItem key={option} value={option}>
                            <Typography className="typography-generic">{option}</Typography>
                          </MenuItem>
                        ))}
                      </Select>
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        // UI page is 1-based; convert back to internal 0-based page index.
                        onChange={(event, page) => this.handleChangePage(page - 1)}
                        shape="rounded"
                        color="primary"
                        showFirstButton
                        showLastButton
                        size="small"
                        renderItem={(item) => (
                          <PaginationItem
                            {...item}
                            className="typography-generic"
                            style={item.selected ? { backgroundColor: 'var(--custom-primary-color)', color: '#ffffff' } : null}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            }
          </Grid>
            
        </Container>

        {/* Error message bar. */}
        <SnackbarCustom message={this.state.errormessage} severity="error" handleonClose={() => { this.setState({ errormessage: null }) }} />
        
        {/* Info message bar. */}
        <SnackbarCustom message={this.state.infomessage} severity="info" handleonClose={() => { this.setState({ infomessage: null }) }} />
        
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/billing/BillingLayout.js